import * as styles from './index.module.scss';
import { observer } from 'mobx-react';
import { ConfigProvider, Layout } from 'antd';
import Nav from './Nav';
import { Navigate, Outlet, Route, Routes, useParams } from 'react-router-dom';
import MainPage from './MainPage';
import { useEffect } from 'react';
import { WorkspacesStore } from '../../../DataSource/Stores/Cabinet/WorkspacesStore';
import toast from 'react-hot-toast';
import ZoningPage from './ZoningPage';
import ArchivePage from './ArchivePage';
import JournalPage from './JournalPage';
import CouriersPage from './CouriersPage';
import OrganizationsPage from './OrganizationsPage';

const DeliveryCenterNew = () => {
  const { id: workspaceId } = useParams();

  useEffect(() => {
    if (!workspaceId) return;

    const getMembers = async () => {
      try {
        const res = await WorkspacesStore.membersGet.call(workspaceId);
        WorkspacesStore.setMembers(res.data);
      } catch (e: any) {
        console.error(e);
        toast.error(e.message.message);
      }
    };

    getMembers();
  }, [workspaceId]);

  return (
    <Routes>
      <Route Component={MainLayout}>
        <Route path="/" element={<MainPage />} />
        <Route path="/zoning" element={<ZoningPage />} />
        <Route path="/archive" element={<ArchivePage />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/couriers" element={<CouriersPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  );
};

export default observer(DeliveryCenterNew);

const MainLayout = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: 'Mulish',
        },
      }}
    >
      <Layout className={styles.layout}>
        <Layout.Sider className={styles.sider} width="auto">
          <Nav />
        </Layout.Sider>

        <Layout.Content className={styles.content}>
          <Outlet />
        </Layout.Content>
      </Layout>
    </ConfigProvider>
  );
};
